import { render, staticRenderFns } from "./OrderStastiticNavBar.vue?vue&type=template&id=055ddd2f&"
import script from "./OrderStastiticNavBar.vue?vue&type=script&lang=ts&"
export * from "./OrderStastiticNavBar.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStastiticNavBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports